<template>
    <div class="u-flex@md wrapper">
        <div class="account-login__side u-mrg-btm-2x u-flex u-flex--column u-flex--justify-center">
            <h2 class="h-xl h-xl-alt u-mrg-btm u-txt-center" v-html="accountSignInTitle"></h2>
            <div class="max-width-sm u-mrg-center u-mrg-btm-half w100">
                <label for="emailLogin" class="u-vis-hidden">
                    <strong>Email address</strong>
                </label>
                <input type="email" name="emailLogin" id="emailLogin" class="input" v-model="email"
                    placeholder="Email Address*" autocomplete="email"
                    :class="{ 'error': submitted && (emailError !== '') }" />
                <div class="error u-hidden" v-html="accountSignInError" aria-live="polite">
                </div>
                <div class="error u-padd-btm-none" v-show="submitted && emailError !== ''">
                    <strong v-html="emailError" aria-live="polite"></strong>
                </div>
                <label for="email" class="u-vis-hidden">
                    <strong>Password</strong>
                </label>
                <input type="password" name="password" id="password" class="input" v-model="password"
                    placeholder="Password*" autocomplete="current-password"
                    :class="{ 'error': submitted && (password === '' || password.length < 8) }" />
                <div class="error u-padd-btm-none" v-show="submitted && invalidPassword">
                    <strong v-html="passError" aria-live="polite"></strong>
                </div>
                <div v-show="error !== ''" class="error" aria-live="polite">
                    <strong>{{ error }}</strong>
                </div>

            </div>
            <div class="u-txt-center u-mrg-center u-mrg-btm-half u-mrg-top-half">
                <button class="btn btn--extra-padd u-txt-center u-mrg-center" @click.prevent="userLoginClick"
                    v-html="accountSignInCta"></button>
            </div>
            <div class="u-txt-center u-mrg-top-half u-txt-sm">
                <strong><a @click.prevent="forgotPassword()" class="link-cta cursor-pointer">Forgot your
                        password?</a></strong>
            </div>
        </div>
        <div class="account-login__side u-flex u-flex--column u-flex--justify-center u-mrg-btm-2x">
            <hr class="u-brdr-color-gray-mist u-hidden@md" />
            <div class="border-left@lg border-color-gray-light">
                <div class="u-mrg-center u-txt-center">
                    <h2 class="h-xl h-xl-alt u-mrg-btm-qtr" v-html="accountCreateAccountTitle"></h2>
                    <p v-html="accountCreateAccountCopy"></p>
                    <button class="btn btn--wide u-inline-block" @click.prevent="createAccount"
                        v-html="accountCreateAccountCta"></button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import UserAPI from '@scripts/utils/api/user';
import { isValidEmail } from '@scripts/utils/forms/helpers';
import UserEvents from '@scripts/utils/events/user';
export default {
    props: {
        //AccountLoginModal props
        accountSignInTitle: String,
        accountSignInError: String,
        accountSignInCta: String,
        accountCreateAccountTitle: String,
        accountCreateAccountCopy: String,
        accountCreateAccountCta: String,

        //page url redirects
        forgotPasswordUrl: String,
        createAccountUrl: String,

        'isModal': {
            default: false,
            type: Boolean
        }
    },
    data() {
        return {
            success: false,
            emailError: '',
            passError: '',
            error: '',
            // remember: false,
            password: '',
            email: '',
            api: null,
            submitted: false,

        };
    },
    methods: {
        userLoginClick() {
            this.submitted = true;
            this.emailError = '';
            this.error = '';
            let email = isValidEmail(this.email)
            let pass = this.password.length >= 8 && this.password != '';
            if (email && pass) {
                this.api.login(this.formData, !this.isModal);
            } else {
                if (!pass) {
                    if (this.password == '') {
                        this.passError = 'Please enter your password.';
                    } else {
                        this.passError = 'Password must be 8 or more characters in length';
                    }
                }
                if (!email) {
                    if (this.email == '') {
                        this.emailError = 'Please enter your email.';
                    } else {
                        this.emailError = 'Email is not valid.';
                    }
                }
            }
        },
        passwordValid(pass) {
            return pass.length >= 8;
        },
        createAccount() {
            if (this.isModal) {
                this.$emit("userAction", "create");
            } else {
                window.location = this.createAccountUrl;
            }
        },
        forgotPassword() {
            if (this.isModal) {
               this.$emit("userAction", "forgot");
            } else {
                window.location = this.forgotPasswordUrl;
            }
        },
        onLoginHandler(e) {
            if (e.detail.success == true || e.detail.success == 'true') {
                if (this.isModal) {
                    this.$emit("userAction", "loggedIn");
                }
            };
        },
        onLoginFailedHandler(e) {
            // event detail is the response object from the User Events and API
            this.error = e.detail.responseText;
        },
    },
    computed: {
        invalidPassword() {
            return !this.passwordValid(this.password);
        },
        invalidEmail() {

        },
        formData() {
            return {
                email: this.email,
                password: this.password,
                // remember: this.remember,
            };
        },
    },
    mounted() {
        this.api = new UserAPI(window.APIDEF);
        const events = new UserEvents();
        window.addEventListener(events.eventLogin, this.onLoginHandler);
        window.addEventListener(events.eventLoginFailed, this.onLoginFailedHandler);
    },
    beforeUnmount() {
        const events = new UserEvents();
        window.removeEventListener(events.eventLogin, this.onLoginHandler);
        window.removeEventListener(events.eventLoginFailed, this.onLoginFailedHandler);
    }
};
</script>
